<template>
  <div class="rootVariantSelector" :class="{ 'align-left': align == 'left' }">
    <div
      class="variant-item"
      v-for="variant in variants"
      :key="variant.id"
      :class="{
        'wide-layout': isWideLayout,
      }"
    >
      <img
        alt="variant"
        class="variant-image"
        @click="selectThisVariant(variant.id)"
        :class="{
          'variant-selected': selectedVariant.id == variant.id,
        }"
        :src="variant.imgSrc"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "variantSelector",
  props: ["isWideLayout", "align"],
  methods: {
    selectThisVariant(id) {
      this.selectVariant(id);
    },
    ...mapMutations({
      selectVariant: "selectVariant",
    }),
  },
  computed: {
    ...mapState({
      variants: (state) => state.variants,
    }),
    ...mapGetters({
      selectedVariant: "selectedVariant",
    }),
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.rootVariantSelector {
  display: flex;
  flex-direction: row;
  justify-content: center;
  column-gap: 1rem;
  flex-wrap: wrap;
  .variant-item {
    text-align: center;
    .variant-image {
      cursor: pointer;
      border: 1px solid transparent;
      transition: all 0.3s ease;
      border-radius: 50%;
      padding: 2px;
      box-sizing: border-box;
      max-width: 40px;
      max-height: 40px;
      &:hover {
        border-color: #999;
      }
      &.variant-selected {
        border: 1px solid #000;
      }
    }
  }
}
@media (min-width: 1024px) {
  .rootVariantSelector {
    column-gap: 0;

    .variant-item {
      &.wide-layout {
        width: 30%;
      }
    }
    &.align-left {
      justify-content: flex-start;
      column-gap: 1rem;
      padding: 0 16px;
    }
  }
}
</style>